import { Br } from "@/components/molecules/Br";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { Stacker } from "@/components/molecules/Stacker";
import { AboutCoverTop } from "@/components/organisms/AboutCover";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { ProductCover } from "@/components/organisms/ProductCover";
import { ProjectNav } from "@/components/organisms/ProjectNav";
import { ServiceCoverTop } from "@/components/organisms/ServiceCover";
import { SolutionSiteBanner } from "@/components/organisms/SolutionSiteBanner";
import { TopNews } from "@/components/organisms/TopNews";
import { TwpBanner } from "@/components/organisms/TwpBanner";
import { TopSNS } from "@/components/organisms/TopSNS";
import { TopTechBlog } from "@/components/organisms/TopTechBlog";
import { ScrollIndicator } from "@/components/organisms/ScrollIndicator";
import { ShindanBanner } from "@/components/organisms/ShindanBanner";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import { Hero } from "@/components/templates/Hero";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import leadProject from "/public/lead-project.svg";
import leadProjectH from "/public/lead-projectH.svg";
import bannerONSTEP from "/public/top-onstep_banner.webp";

export const getStaticProps = async () => {
  const { fetchAllNews } = await import("@/lib/news-api");

  const headers = {
    "X-MICROCMS-API-KEY": process.env.X_MICROCMS_API_KEY,
  };

  // ニュースリリース一覧の取得（microCMS + TWP統合）
  const allNews = await fetchAllNews({ limit: 5 });

  // エンジニアブログ一覧の取得
  const techBlogListApiUrl = "https://ab1ue7gpa0.microcms.io/api/v1/techblog";

  const techBlogResponse = await fetch(techBlogListApiUrl, {
    headers: headers,
  });
  const techBlogJson = await techBlogResponse.json();

  return {
    props: {
      contents: allNews,
      techblog: techBlogJson?.contents ? techBlogJson.contents : [],
    },
    // ISR: 60秒ごとに再生成（TWP CMSで公開したニュースをビルドなしで反映する）
    revalidate: 60,
  };
};

export default function TopPage(props) {
  const SliderWithNoSSR = dynamic(() => import("@/components/templates/Hero"), {
    ssr: false,
  });

  const { parse } = useBudouX();
  return (
    <>
      <Meta
        pageTitle={
          "Specialize in your BUSINESS あなたのビジネスに、トッカするシステムを | トップページ（Top）"
        }
        pageDescription={
          "株式会社トッカシステムズのトップページ（Top）です。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/"}
        ogTitle={"トップページ（Top）"}
      />
      <Layout>
        <Header className="shadow-none" />
        <ScrollIndicator />
        <main className="flex-1">
          <Container>
            <Hero />
            <Inner className="max-w-7xl">
              <div className="pt-0 md:pt-2 lg:pt-4">
                                <section>
                                  <Link href="/service">
                                    <a className="hover:opacity-80">
                                      <ServiceCoverTop />
                                    </a>
                                  </Link>
                                </section>
                                <section className="mt-4 md:mt-8">
                                  <TwpBanner />
                                </section>
                                <section className="mt-4 md:mt-8">
                                  <SolutionSiteBanner />
                                </section>
                                <Stacker>
                  <section>
                    <Link href="/product">
                      <a className="hover:opacity-80">
                        <ProductCover />
                      </a>
                    </Link>
                    <Link href="/product/onstep">
                      <a className="hover:opacity-80">
                        <Image
                          src={bannerONSTEP}
                          alt="ファンマ（ファンマーケティング）を次のステージへ。 ONLINE SALON Platform ONSTEP"
                          quality={80}
                          width={1272}
                          height={360}
                        />
                      </a>
                    </Link>
                  </section>
                  <section className="space-y-4 md:space-y-0">
                    <div className="relative mx-auto box-border flex max-w-7xl flex-col justify-between gap-2 px-6 text-txt-base sm:px-8 md:my-8 md:px-12 lg:flex-row lg:items-end xl:px-0">
                      <div>
                        <h6 className="mb-2 text-sm font-bold text-pri md:mb-6 md:text-md ">
                          Project
                        </h6>
                        <h2 className="relative aspect-12/1 h-auto fluid-width-[280px,334px] lg:aspect-3.48/1">
                          <span className="hidden lg:block">
                            <Image
                              src={leadProject}
                              alt="システムを軸にした成長運用"
                              quality={80}
                              layout="fill"
                              objectFit="cover"
                            />
                          </span>
                          <span className="block lg:hidden">
                            <Image
                              src={leadProjectH}
                              alt="システムを軸にした成長運用"
                              quality={80}
                              width={503}
                              height={44}
                            />
                          </span>
                        </h2>
                      </div>
                      <div className="max-w-[616px]">
                        <h3 className="mb-2 font-bold leading-comfort text-txt-base fluid-text-[14px,18px] md:mb-4 ">
                          企画から設計・製作・メンテナンスまで、
                          <Br tbpc />
                          <br className="br_sm" />
                          一貫体制でお客さまの体験価値の向上に真摯に向き合います。
                        </h3>
                        <p className="text-xs text-txt-light">
                          ※各事例は、機密情報保持契約を遵守した上で、特定されないように配慮した上で掲載しています
                        </p>
                      </div>
                    </div>
                    <ProjectNav className="mb-6 max-w-7xl md:mb-14" />
                  </section>
                  <section>
                    <div className="px-6 sm:px-8 md:px-12 xl:px-0 mx-auto max-w-7xl">
                      <ShindanBanner />
                    </div>
                  </section>
                  <section>
                    <Link href="/about">
                      <a className="hover:opacity-80">
                        <AboutCoverTop />
                      </a>
                    </Link>
                    <div className="relative mx-auto mt-4 mb-8 box-border flex max-w-7xl flex-col justify-between gap-2 px-6 text-txt-base sm:px-8 md:px-12 lg:mt-8 lg:mb-0 lg:flex-row lg:items-start xl:px-0">
                      <h6 className="font-bold text-pri fluid-text-[16px,22px] ">
                        About ToccaSystems
                      </h6>
                      <div className="md:max-w-[616px]">
                        <h3 className="font-bold leading-comfort text-txt-base fluid-text-[14px,18px] ">
                          デジタルテクノロジーの持つ合理性に、思いやりと創造性を掛け合わせ、お客様に寄り添う、人の顔が見えるサービスをお届けしたいと考えています。
                        </h3>
                      </div>
                    </div>
                  </section>
                  <section>
                    <TopNews articles={props.contents} />
                  </section>
                  <section>
                    <TopSNS />
                  </section>
                  <section>
                    <TopTechBlog blogs={props.techblog} />
                  </section>
                </Stacker>
              </div>
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
